import {
  fetchAllLandingPageConfig,
  fetchLandingPageConfigWithShortname,
  fetchLandingPageServices,
  findBySrvrtid,
} from 'api/merchant';
import { useEffect, useState } from 'react';
import { MerchantLandingPageWithLayout } from '../merchant-landing';
import MerchantLandingLoadingStates from '@components/common/layout/merchant-landing-page/loading-states';
import Head from 'next/head';

export async function getStaticPaths() {
  const output = await fetchAllLandingPageConfig();
  const outputValue = Array.isArray(output) ? output : [];
  const merchantConfigs =
    outputValue &&
    outputValue?.filter((item) => {
      if (item.shortname && item.ms) {
        return item;
      }
    });
  const paths = merchantConfigs.map((item) => ({ params: { shortname: item.shortname } }));
  return {
    paths: paths,
    fallback: false,
  };
}

export async function getStaticProps(context) {
  // const merchantConfig = await fetchLandingPageConfigWithShortname(context.params.shortname);
  // const merchantServices = await fetchLandingPageServices(merchantConfig.ms);
  // const merchant = await findBySrvrtid(merchantConfig.ms);
  // return {
  //   props: {
  //     data: {
  //       merchant,
  //       merchantServices,
  //       merchantSrvrtid: merchantConfig.ms,
  //       merchantLandingConfig: merchantConfig,
  //       shortname:context.params.shortname,
  //     },
  //   }
  // }

  const merchantData = await getMerchantData(context.params.shortname);
  return {
    props: {
      data: merchantData,
    },
  };
}

function MerchantLanding({ data, ...props }) {
  const [loading, setLoading] = useState(true);
  const [merchantData, setMerchantData] = useState(data);

  useEffect(() => {
    (async () => {
      const merchant_Data = await getMerchantData(data.shortname);
      setMerchantData(merchant_Data);
      console.log('merchant_Data', merchant_Data);
      setLoading(false);
    })();
  }, []);

  return (
    <>
      <Head>
        <title>{merchantData.merchant.official_name}</title>
        <meta name="title" content={merchantData.merchant.official_name} />
        <meta name="description" content={merchantData.merchantLandingConfig.message} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={process.env.WEBSITE_URL + '/pay/' + merchantData.merchant.official_name} />
        <meta property="og:title" content={merchantData.merchant.official_name} />
        <meta property="og:description" content={merchantData.merchantLandingConfig.message} />
        <meta property="og:image" content={process.env.WEBSITE_URL + '/' + merchantData.merchant.logo_large_img} />
      </Head>
      {loading ? <MerchantLandingLoadingStates /> : <MerchantLandingPageWithLayout {...props} {...merchantData} />}
    </>
  );
}

export default MerchantLanding;

async function getMerchantData(shortname) {
  const merchantConfig = await fetchLandingPageConfigWithShortname(shortname);
  const merchantServices = await fetchLandingPageServices(merchantConfig.ms);
  const merchant = await findBySrvrtid(merchantConfig.ms);
  return {
    merchant,
    shortname,
    merchantServices,
    merchantSrvrtid: merchantConfig.ms,
    merchantLandingConfig: merchantConfig,
  };
}
